import Axios from 'axios';
import { setupCache } from "axios-cache-interceptor";

const axios = setupCache(Axios, {
  methods: ['get']
});
const axiosInstance = axios.create({
  baseURL: `/api`,
});

export default axiosInstance;
